<template>
  <div>
    <v-row>
      <v-col>
        <download-excel v-if="$store.getters.hasPermission('Proyectos', 'Descargar')" :data='downloadTable'
          worksheet='Data' style="display: inline-block;">
          <v-btn v-if="$store.getters.hasPermission('Proyectos', 'Descargar')" color="primary">
            Descargar data
            <v-icon> mdi-download </v-icon>
          </v-btn>
        </download-excel>
      </v-col>
    </v-row>
    <v-data-table 
      :headers="headers" 
      :items="proyectos" 
      item-key="name" 
      class="elevation-1" 
      :search="search"
      :loading="isLoading">
      <template v-slot:item.accions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon 
              v-if="$store.getters.hasPermission('Proyectos', 'Editar')" 
              small class="mr-2" 
              v-bind="attrs"
              @click="editarProyecto(item)" 
              v-on="on"
              >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon 
              v-if="$store.getters.hasPermission('Proyectos', 'Prospección')" 
              small 
              class="mr-2" 
              v-bind="attrs"
              v-on="on" 
              @click="prospectarProyecto(item)"
              >
              mdi-clipboard-text-outline
            </v-icon>
          </template>
          <span>Prospectar</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon 
              small 
              class="mr-2 ml-2" 
              v-bind="attrs" 
              @click="verProyecto(item)" 
              v-on="on"
              >
              mdi-eye
            </v-icon>
          </template>
          <span>Inspeccionar</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon 
              small 
              class="mr-2" 
              v-bind="attrs" 
              v-on="on" 
              @click="comentariosProyecto(item)"
              >
              mdi-comment-quote
            </v-icon>
          </template>
          <span>Comentarios</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon 
              v-if="$store.getters.hasPermission('Proyectos', 'Eliminar')" 
              small 
              class="mr-2" 
              v-bind="attrs"
              v-on="on" 
              @click="openDialogEliminarProyecto(item)"
              >
              mdi-trash-can-outline
            </v-icon>
          </template>
          <span>Eliminar proyecto</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog v-model="isVerProyecto.status" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ isVerProyecto.data.nombre }} - {{ isVerProyecto.data.codigo }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <div class="ml-4">
                  <strong>Longitud:</strong> {{ isVerProyecto.data.longitud }}
                  <br>
                  <strong>Latitud:</strong> {{ isVerProyecto.data.latitud }}
                  <br>
                  <strong>Region:</strong> {{ isVerProyecto.data.region }}
                  <br>
                  <strong>Provincia:</strong> {{ isVerProyecto.data.provincia }}
                  <br>
                  <strong>Tipo de Obra:</strong> {{ isVerProyecto.data.tipo }}
                  <br>
                  <strong>Categoria:</strong> {{ isVerProyecto.data.categoria }}
                  <br>
                  <strong>Estado de negociacion:</strong> {{ isVerProyecto.data.estadoNegociacion }}
                  <br>
                  <strong>Entrega:</strong> {{ isVerProyecto.data.fechaEntrega }}
                  <br>
                  <strong>Etapa:</strong> {{ isVerProyecto.data.etapa }}
                  <br>
                  <strong>Direccion:</strong> {{ isVerProyecto.data.direccion }}
                  <br>
                  <strong>Inmobiliaria:</strong> {{ isVerProyecto.data.inmobiliaria }}
                  <br>
                  <strong>Proveedor Actual:</strong> {{ isVerProyecto.data.proveedorActual }}
                  <br>
                  <strong>Constructora:</strong> {{ isVerProyecto.data.constructora }}
                  <br>
                  <strong>Foto:</strong>
                  <a :href="isVerProyecto.data.foto" target="_blank">
                    Ver foto
                  </a>
                  <br>
                  <strong>Pisos:</strong> {{ isVerProyecto.data.numeroPisos }}
                  <br>
                  <strong>Departamentos:</strong> {{ isVerProyecto.data.numeroDepartamentos }}
                  <br>
                  <strong>Frec. Visitas:</strong>
                  <a v-if="isVerProyecto.data.visitas === 0">
                    Sin visitas registradas
                  </a>
                  <a v-else @click="visitedItem(isVerProyecto.data)">
                    {{ isVerProyecto.data.visitas }}
                  </a>
                  <br>
                  <strong>Fecha creación:</strong> {{ isVerProyecto.data.fechaCreacion }}
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="isVerProyecto.status = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialogComment" width="100%">
          <v-card>
            <v-card-title class="text-h5">
              Comentarios del proyecto
            </v-card-title>

            <v-card-text>
              <v-text-field v-model="commentario" label="Agrege un comentario" outlined />
              <v-alert v-if="invalidComment" type="error" dense class="mt-2">
                El comentario es muy corto.
              </v-alert>
              <v-btn :loading="isLoadingComment" @click="addComment()">
                Agregar comentario
              </v-btn>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <template>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Usuario
                        </th>
                        <th class="text-left">
                          Comentario
                        </th>
                        <th class="text-left">
                          Comentado el:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="comment in commentsProyecto" :key="comment.i">
                        <td>{{ comment.usuario }}</td>
                        <td style="white-space: pre-line;">{{ comment.comment }}</td>
                        <td>{{ formatFecha(comment.createdAt) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
            </v-card-text>
            <v-divider></v-divider>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogConfirmEliminar" persistent max-width="500">
          <v-card>
            <v-card-title>
              ¿Esta seguro de eliminar este proyecto?
            </v-card-title>
            <v-card-text>Una vez que elimina el proyecto ya no podra recuperarlo</v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="green darken-1" text @click="dialogConfirmEliminar = false">
                Cancelar
              </v-btn>
              <v-btn color="green darken-1" text :loading="isLoadingEliminar" @click="eliminarProyecto()">
                Aceptar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import { mapActions } from 'vuex'
import firebase from 'firebase'
export default {
  props: ['proyectos', 'isLoading', 'search'],
  data() {
    return {
      isLoadingComment:false,
      invalidComment: false,
      dialogConfirmEliminar: false,
      setEliminarProyectoCodigo: null,
      isLoadingEliminar: false,
      usuarios: [],
      dialogComment: false,
      selectProyecto: null,
      commentsProyecto: [],
      commentario: '',
      showRegistroProyecto: false,
      isVerProyecto: {
        status: false,
        data: '',
      },
      prospectoras: ['uno', 'dos'],
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Nombre de proyecto',
          align: 'start',
          sortable: false,
          value: 'nombre',
        },
        { text: 'Región', value: 'region' },
        { text: 'Provincia/Distrito', value: 'provincia' },
        { text: 'Inmobiliaria', value: 'inmobiliaria' },
        { text: 'Constructora', value: 'constructora' },
        { text: 'Estado Negociacion', value: 'estadoNegociacion' },
        { text: 'Entrega', value: 'fechaEntrega' },
        { text: 'Asesor', value: 'asesor' },
        { text: 'Etapa', value: 'etapa' },
        { text: 'Accions', value: 'accions' },
      ]
    },
    listYear: function () {
      return [2021, 2022, 2023, 2024]
    },
    downloadTable: function () {
      var downloadData = []
      this.proyectos.forEach(proyecto => {
        const data = {
          MODULO: 'Prospección',
          LATITUD: proyecto.latitud,
          LONGITUD: proyecto.longitud,
          REGION: proyecto.region,
          PROVINCIA: proyecto.provincia,
          CÓDIGO: "'" + proyecto.codigo,
          CATEGORÍA: proyecto.categoria,
          'TIPO DE OBRA': proyecto.tipo,
          PROPIETARIO: proyecto.inmobiliaria,
          CONSTRUYE: proyecto.constructora,
          DIRECCIÓN: proyecto.direccion,
          PROYECTO: proyecto.nombre,
          PROSPECTOR: proyecto.prospector,
          ASESOR: proyecto.asesor,
          'ESTADO NEGOCIACION': proyecto.estadoNegociacion,
          'TIPO CLIENTE': proyecto.tipoCliente,
          'PROVEEDOR ACTUAL': proyecto.proveedorActual,
          'PROVEEDOR ACTUAL AGRUPADO': proyecto.proveedorActualAgrupado,
          ETAPA: proyecto.etapa,
          PISOS: proyecto.numeroPisos,
          DEPARTAMENTOS: proyecto.numeroDepartamentos,
          'RANGO VIVIENDA': proyecto.rangoVivienda,
          AÑO: proyecto.anio,
          ENTREGA: '\'' + proyecto.fechaEntrega,
          FOTO: proyecto.foto,
          COTIZACION: proyecto.cotizacion,
          FACTURACION: proyecto.facturacionProyectada,
          IPV: proyecto.ipv,
          'CANTIDAD PUERTAS': proyecto.cantidadPuertas,
          'MONTO PUERTAS': proyecto.montoPuertas,
          'MONTO CERRADURA Y BIZAGRA': proyecto.montoCerraduras,
          'CANTIDAD CORTAFUEGO': proyecto.cantidadCortafuego,
          'CANTIDAD DUCTOS': proyecto.cantidadDuctos,
          'MONTO CORTAFUEGO Y DUCTOS': proyecto.montoCortafuego,
          'HUBO REUNION': proyecto.reunion,
          'TIPO SISTEMA': proyecto.tipoSistema,
          'POSIBILIDAD CIERRE': proyecto.posibilidadCierre,
          'QUIEN GANÓ': proyecto.quienGano,
          'MEDIO CONTACTO': proyecto.medioContacto,
          'POR QUIEN SE PERDIÓ': proyecto.razonPerdido,
        }
        downloadData.push(data)
      })
      return downloadData
    },
  },
  methods: {
    downloadData() {
      Vue.component('downloadExcel', JsonExcel)
    },
    ...mapActions(['setProspectarProyecto']),
    editarProyecto(data) {
      this.$emit('editarProyecto', data)
    },
    openDialogEliminarProyecto(data) {
      this.dialogConfirmEliminar = true
      this.setEliminarProyectoCodigo = data
    },
    eliminarProyecto() {
      this.isLoadingEliminar = true
      console.log("Se eliminará el siguiente proyecto de manera irreversible: "
        , this.setEliminarProyectoCodigo, this.setEliminarProyectoCodigo.nombre)
      firebase.firestore().collection('proyectos').doc(this.setEliminarProyectoCodigo.codigo).delete().then(() => {
        this.dialogConfirmEliminar = false
        this.isLoadingEliminar = false
        this.$emit('actualizarTable', true)
      })
    },
    prospectarProyecto(data) {
      this.setProspectarProyecto(data)
      this.$router.push('/proyectos/prospeccion/prospectar/')
    },
    visitedItem(item) {
      this.setProspectarProyecto(item)
      this.$router.push('/proyectos/prospeccion/visitas/')
    },
    verProyecto(data) {
      this.isVerProyecto.status = true
      this.isVerProyecto.data = data
    },
    comentariosProyecto(data) {
      this.selectProyecto = data.codigo
      this.commentsProyecto = data.comments
      this.commentario = ''
      this.dialogComment = true
    },
    addComment() {
      this.isLoadingComment=true
      const texto = (this.commentario || '').trim();
      if (texto.length < 5) {
        this.invalidComment = true;
        this.isLoadingComment = false
        return;
      }
      this.invalidComment = false;
      const user = JSON.parse(localStorage.userAuth)
      const newComment = {
        usuario: user.email,
        createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
        comment: this.commentario,
      }
      firebase.firestore().collection('proyectos').doc(this.selectProyecto).update({
        comments: firebase.firestore.FieldValue.arrayUnion(newComment)
      }).then(() => {
        this.commentario = ''
        firebase.firestore().collection('proyectos').doc(this.selectProyecto).get().then(doc => {
          if (doc.exists) {
            const data = doc.data()
            this.commentsProyecto = data.comments || []
            this.isLoadingComment=false
            this.comentariosProyecto()
          }
        })
      })
    },
    formatFecha(timestamp) {
      return timestamp && timestamp.toDate
        ? timestamp.toDate().toLocaleString()
        : 'Sin fecha'
    },
  },
}
</script>
